import React, { useEffect } from "react";

import { ItemPreview } from "@examspark/common-app";
import { usePaginate } from "@examspark/common-hooks";
import { DismissButton, ModalProps } from "@examspark/common-ui";
import { Resource } from "@examspark/types";

import Modal from "../common/Modal";

const UnitItemsModal = (
  props: ModalProps & {
    items?: Resource[];
  },
) => {
  const { items } = props;
  const paginate = usePaginate<Resource>();

  useEffect(() => {
    paginate.setItems(items ?? []);
  }, [items, paginate]);

  return (
    <Modal
      title={`Assessment Items${items?.length ? ` (${items.length})` : ""}`}
      size="large"
      buttons={<DismissButton onDismiss={props.onRequestClose} />}
      {...paginate.props}
      {...props}
    >
      {paginate.item?.id && <ItemPreview itemId={paginate.item.id} />}
    </Modal>
  );
};

export default UnitItemsModal;
